import { type SchemaSettingsHierarchy } from '@/shared/api/openApi';
import type { IMerchSettingRepository } from './types/IMerchSettingRepository';
import { merchSettingRepository } from './merchSettingRepository';
import { type SettingsPartsPaths } from './types';

export class MerchSettingService {
    constructor(private readonly repository: IMerchSettingRepository = merchSettingRepository) {}

    async getSettingsByPaths(paths: SettingsPartsPaths[], storeSlug: string): Promise<SchemaSettingsHierarchy> {
        return await this.repository.getSettingsByPaths(paths, storeSlug);
    }
}

export const merchSettingService = new MerchSettingService();
